export const parseCity = data => ({
  type: 'FeatureCollection',
  features: data.map(({ city_name, country_name, longitude, latitude, IQ }) => {
    if (city_name && country_name && longitude && latitude && IQ) {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [Number(longitude), Number(latitude)]
        },
        properties: {
          address: city_name,
          country: country_name,
          score: Number(Math.round(Number(IQ))),
          latitude: Number(latitude),
          longitude: Number(longitude)
        }
      };
    } else {
      console.log('INVALID DATA POINT');
      console.log(city_name);
      return null;
    }
  })
});
